// Central brand content + assets for The Safety Quest
export const AMAZON_URL = "https://a.co/d/0jdaoV8u"; // Fire Safety with Bobby and Pluggy
export const AMAZON_URL_SEATBELT = "https://a.co/d/0idnwF6t"; // Ready, Set, Click: Seat Belt Safety

// Paste a YouTube/Vimeo watch or embed URL (or a direct .mp4) to enable the Sales-page demo reel.
// Leave empty ("") to show the "coming soon" poster.
export const PLUGGY_VIDEO_URL = "";

export const IMAGES = {
  bobby: "/characters/bobby.png",
  pluggy: "/characters/pluggy.png",
  bookCover: "https://customer-assets.emergentagent.com/job_quest-for-safety/artifacts/q8basmv5_inbound3567952181235130303.jpg",
  bookCoverSeatbelt: "https://customer-assets.emergentagent.com/job_quest-for-safety/artifacts/s67xglf8_inbound572456273145366595.jpg",
  heroScene: "https://static.prod-images.emergentagent.com/jobs/12617115-629c-4e84-b30d-6aab8c7efdde/images/48e2765b4ca50bebafd325d14335dad0619ccb2400dc4a646a01340c1bd1c892.png",
  roboticsAssembly: "https://customer-assets.emergentagent.com/job_quest-for-safety/artifacts/oy4c8qx0_ghows_image-WL-2f2cef59-4ee6-439b-ba7e-6b5d477b14cf.jpeg",
  roboticsLineup: "https://customer-assets.emergentagent.com/job_quest-for-safety/artifacts/ccu4jn3q_Screenshot_20260714-144505.png",
  toddlerFire: "https://images.unsplash.com/photo-1504850012971-3dc85a46dc4a",
  kidsReading: "https://images.unsplash.com/photo-1549737221-bef65e2604a6",
  classroom: "https://images.unsplash.com/photo-1577896851231-70ef18881754",
  schoolBus: "https://images.unsplash.com/photo-1583508805133-8fd03a9916d4",
  seatbeltSafety: "https://static.prod-images.emergentagent.com/jobs/12617115-629c-4e84-b30d-6aab8c7efdde/images/da63e625c830bdfd26ff0a2eae426ecb8a2abf57a5fdc10108b7413e4267e109.jpeg",
  crosswalkSafety: "https://static.prod-images.emergentagent.com/jobs/12617115-629c-4e84-b30d-6aab8c7efdde/images/49fad8b0ac0d22160a3fea38edb9ce114756aef6ca311a9b6942e27524d0bf9d.jpeg",
};

export const BOOKS = [
  {
    id: "fire",
    series: "The Safety Quest",
    title: "Fire Safety with Bobby and Pluggy",
    cover: IMAGES.bookCover,
    amazon: AMAZON_URL,
    available: true,
    blurb: "The debut Safety Quest adventure. Join firefighter Bobby and his sidekick Pluggy the fire hydrant as they teach young readers how to prevent fires, escape safely, and become confident Safety Heroes at home.",
  },
  {
    id: "seatbelt",
    series: "The Safety Quest",
    title: "Ready, Set, Click: Seat Belt Safety",
    cover: IMAGES.bookCoverSeatbelt,
    amazon: AMAZON_URL_SEATBELT,
    available: true,
    blurb: "Buckle up for the next quest! Bobby teaches kids why every ride starts with a click — the fun, memorable way to build lifelong seat belt habits for the whole family.",
  },
];

const SONG_BASE = "https://customer-assets.emergentagent.com/job_quest-for-safety/artifacts";
export const SONGS = [
  { id: "stop-drop-roll", title: "Stop, Drop & Roll", desc: "The classic move — now a beat you can't forget.", url: `${SONG_BASE}/snfxlzfx_stop_drop_and_roll.mp4` },
  { id: "get-low-go", title: "Get Low & Go", desc: "Stay under the smoke and get outside fast.", url: `${SONG_BASE}/evttuiou_get_low_and_go.mp4` },
  { id: "three-feet-back", title: "Three Feet Back", desc: "Keep a safe space around heaters, stoves & flames.", url: `${SONG_BASE}/lf0tkd05_three_feet_back.mp4` },
  { id: "safety-hero-shuffle", title: "The Safety Hero Shuffle", desc: "The official dance of every Safety Hero.", url: `${SONG_BASE}/cqdb5qaa_the_safety_hero_shuffle-1.mp4` },
];

export const CONTACT = {
  phone: "(404) 453-8389",
  phoneHref: "tel:+14044538389",
  email: "bobbyandpluggy@gmail.com",
  location: "Serving communities across Georgia, USA",
};

export const SOCIAL = {
  instagram: "https://www.instagram.com/bobbyandpluggy",
  facebook: "https://www.facebook.com/share/1Bbw6RNLNK/",
  youtube: "https://www.youtube.com/@bobbyandpluggy",
};

export const BRAND_VIDEO = "https://customer-assets-cm19k8pv.emergentagent.net/job_quest-for-safety/artifacts/9biri3nq_final%20bobby.mp4";
export const MUSIC_VIDEO = "https://customer-assets-cm19k8pv.emergentagent.net/job_quest-for-safety/artifacts/bn0usekg_bobby%20Video%20song%20final.mp4";

export const YOUTUBE_EPISODE = { id: "Xhgs3BqWU7M", title: "The Safety Quest with Bobby & Pluggy — Episode 1" };

export const SAFETY_PRINCIPLES = [
  "Stop, Drop & Roll", "Buckle Up Every Ride", "Look Both Ways", "Know Your Exits",
  "Call 9-1-1", "Stay Low In Smoke", "Cross At The Corner", "Be A Safety Hero",
];

export const LESSONS = [
  {
    id: "stop-drop-roll",
    title: "Stop, Drop & Roll",
    color: "sq-red",
    steps: ["STOP where you are — don't run.", "DROP to the ground and cover your face.", "ROLL over and over until the flames are out."],
    tip: "If your clothes ever catch fire, these three moves keep you safe.",
  },
  {
    id: "crosswalk",
    title: "Crosswalk Safety",
    color: "sq-blue",
    steps: ["Find the corner or crosswalk.", "Look LEFT, then RIGHT, then LEFT again.", "Make eye contact with drivers, then walk — don't run."],
    tip: "The safest place to cross is always at a marked crosswalk.",
  },
  {
    id: "seatbelt",
    title: "Seat Belt Safety",
    color: "sq-yellow",
    steps: ["Buckle up before the car moves.", "Keep the belt low and snug across your hips.", "Stay in your booster seat until you're big enough."],
    tip: "Click it every single time — even for short trips.",
  },
];

export const TEAM = [
  {
    name: "Bobby Martin",
    role: "Founder · Former Firefighter",
    bio: "A former firefighter, Bobby spent years on the front lines of fire prevention. The Safety Quest was born from his mission to give kids the confidence and know-how to stay safe.",
  },
  {
    name: "Nekia Martin",
    role: "Co-Founder · Creative Director",
    bio: "Nekia shapes the heart of the brand — the stories, characters and lessons that make safety feel like an adventure kids actually want to go on.",
  },
  {
    name: "Kudakwashe Dzapasi",
    role: "International Partner · US & Africa",
    bio: "Leading the brand's global footprint, Kudakwashe brings The Safety Quest to communities across the US and Africa with locally rooted safety initiatives.",
  },
  {
    name: "Ja'Corey Martin",
    role: "Jco · The Safety Instructor",
    bio: "Operator and the voice of Pluggy during our live performances — Jco brings the hydrant hero to life and keeps every assembly fun, energetic and safe.",
  },
  {
    name: "Ja'Courtney Martin",
    role: "CoCo Safety · Read-Along Host",
    bio: "CoCo Safety hosts our book read-alongs on YouTube, guiding kids through every Safety Quest story with warmth and excitement.",
  },
  {
    name: "Khloe Martin",
    role: "Klo Motion · Choreographer & Lead Dancer",
    bio: "Choreographer, lead dancer and sing-along vocalist — Khloe turns safety songs into the dance moves kids can't stop doing.",
  },
];

export const PROGRAMS = [
  { title: "Daycare Safety Days", desc: "Interactive, age-appropriate assemblies for ages 3–5 featuring Bobby & Pluggy, songs and hands-on drills.", audience: "Daycares" },
  { title: "Elementary School Programs", desc: "Curriculum-aligned safety workshops covering fire, road and home safety for grades K–5.", audience: "Schools" },
  { title: "Community Safety Events", desc: "Localized programs and family safety fairs across Georgia — bringing fire trucks, books and heroes to your neighborhood.", audience: "Communities" },
];
